<dx-select-box [items]="items"
               (onValueChanged)="onMeetingOrTemplateChanged($event)"
               [displayExpr]="getDisplayText"
               [value]="meetingOrTemplate">
    <div *dxTemplate="let item of 'item'">
        @if (isMeeting(item)) {
            <small>
                (meeting)
            </small>
        } @else {
            <small>
                (template)
            </small>
        }

        {{ item.name }}
        @if (isMeeting(item)) {
            <small>
                at {{ item.meetingDateTime | date: 'medium' }}
            </small>
        }
    </div>
</dx-select-box>
